import React from "react";
import Navbar from '../accueil/navbar/Navbar';
import Footer from '../accueil/footer/Footer';
import Bureau from "./bureau/Bureau";
import TabSelector from './TabSelector';
import "./body.css";

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class DisplayBureau extends React.Component {
    constructor() {
        super();
        this.state = {
            bureau: [],
            activeId: ''
        }
    }

    componentDidMount = () => {

        fetch(SERVER_ADDRESS + '/bureaux')
            .then(res => res.json())
            .then(res => this.setState({ bureau: res, activeId: res[0].ville }))
    }

    handleChangeTab = (event) => {
        const buttonId = event.target.id;
        this.setState({ activeId: buttonId });

    }

    render() {
        return (
            <div className="sticky-wrap">
                <Navbar />
                <div className="all_bureau_page column">
                    <h1 className="title_glob lg-3">Nos locaux</h1>
                    <TabSelector activeId={this.state.activeId} handleChangeTab={this.handleChangeTab} />
                    {
                        this.state.bureau.map((bureaux) => {
                            if (this.state.activeId === bureaux.ville) {
                                return (
                                    <Bureau
                                        fax={bureaux.fax}
                                        numero={bureaux.numero}
                                        adresse={bureaux.adresse}
                                        code_postal={bureaux.code_postal}
                                        ville={bureaux.ville}
                                        telephone={bureaux.telephone}
                                        email={bureaux.email}
                                        heure_debut={bureaux.heure_debut}
                                        heure_pause={bureaux.heure_pause}
                                        heure_reprise={bureaux.heure_reprise}
                                        heure_fin={bureaux.heure_fin}
                                        iframe={bureaux.iframe}
                                        compte_email={bureaux.compte_email}
                                        mdp_email={bureaux.mdp_email}
                                        id={bureaux.id}
                                    />
                                )
                            } else {return ""}
                        })
                    }
                </div>
                <div className="sticky-footer">
                    <Footer />
                </div>
            </div >
        )
    }
}

export default DisplayBureau;
